import { Icon } from '@chakra-ui/react'

export const PencilIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.282 2.57047C10.2327 2.52116 10.1527 2.52116 10.1034 2.57047L8.06191 4.61198L11.2752 7.9187L13.3634 5.8305C13.4127 5.78119 13.4127 5.70121 13.3634 5.65189L10.282 2.57047ZM10.4266 8.76731L7.21329 5.46059L2.74103 9.93282C2.71835 9.95552 2.70513 9.98601 2.70409 10.018L2.60047 13.2031C2.5981 13.276 2.65791 13.3358 2.7308 13.3334L5.91584 13.2298C5.94768 13.2287 5.97827 13.2156 6.00103 13.1928L10.4266 8.76731ZM6.79515 4.18167L9.25488 1.72197C9.77282 1.20402 10.6126 1.204 11.1306 1.72195L14.212 4.80336C14.7299 5.32131 14.7299 6.16107 14.212 6.67901L6.8496 14.0413C6.61154 14.2794 6.29168 14.4182 5.95487 14.4291L2.76984 14.5328C2.00378 14.5577 1.37619 13.93 1.40111 13.1641L1.50472 9.97903C1.51568 9.64241 1.6543 9.32252 1.89246 9.08434L5.44364 5.53316L6.79515 4.18167Z" fill="#19191A" />
    </svg>



)

